<!-- Modal de Agregar Tarjeta -->
@if (showModal) {
<div class="fixed inset-0 z-50 flex items-center justify-center">
  <!-- Overlay oscuro -->
  <div class="absolute inset-0 bg-gray-950/50" (click)="closeModal()"></div>
  <!-- Contenido del Modal -->
  <div
    class="relative bg-gray-900 rounded-lg shadow-xl w-full max-w-md mx-4 overflow-hidden"
  >
    <!-- Encabezado del Modal -->
    <div class="flex items-center justify-between p-4 border-b border-gray-700">
      <h3 class="text-xl font-semibold text-white">Agregar Tarjeta</h3>
      <button
        type="button"
        class="text-gray-400 bg-transparent hover:bg-gray-700 hover:text-white rounded-lg p-1.5"
        (click)="closeModal()"
      >
        <svg
          class="w-5 h-5"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
            clip-rule="evenodd"
          ></path>
        </svg>
      </button>
    </div>
    <!-- Cuerpo del Modal -->
    <div class="p-6">
      <!-- Visualización de la Tarjeta -->
      <div class="mb-6 relative">
        <div
          [ngClass]="[
            cardBrandColor,
            'rounded-lg p-4 text-white shadow-md transition-all duration-300'
          ]"
        >
          <div class="flex justify-between items-center mb-4">
            <div
              class="w-12 h-8 bg-white bg-opacity-20 rounded flex items-center justify-center"
            >
              <div class="w-8 h-5 bg-gray-400 rounded"></div>
            </div>
            <div class="text-sm font-medium uppercase">
              {{ cardBrand || "DEBIT" }}
            </div>
          </div>
          <div class="mb-6 tracking-wider text-lg font-medium">
            •••• •••• •••• ••••
          </div>
          <div class="flex justify-between text-sm">
            <div>
              <div class="text-xs text-white text-opacity-80">Titular</div>
              <div class="text-white">
                {{ cardForm.get("cardholder-name")?.value || "NOMBRE TITULAR" }}
              </div>
            </div>
            <div>
              <div class="text-xs text-white text-opacity-80">Expira</div>
              <div>MM/YY</div>
            </div>
          </div>
        </div>
      </div>
      <!-- Formulario de Stripe -->
      <form [formGroup]="cardForm" class="space-y-4">
        <!-- Nombre del titular -->
        <div class="space-y-2">
          <label class="block text-sm font-medium text-gray-300">
            Nombre del titular
          </label>
          <input
            id="cardholder-name"
            type="text"
            formControlName="cardholder-name"
            class="w-full px-3 py-3 bg-gray-700 border border-gray-600 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Nombre completo del titular"
            required
            maxlength="30"
          />
        </div>
        <!-- Elemento de tarjeta de Stripe -->
        <div class="space-y-2">
          <label class="block text-sm font-medium text-gray-300">
            Información de la tarjeta
          </label>
          <div class="relative">
            <div
              id="stripe-card-element"
              #stripeCardElement
              class="w-full p-4 bg-gray-700 border border-gray-600 rounded-lg min-h-[60px] transition-all duration-200 focus-within:border-blue-500 focus-within:ring-2 focus-within:ring-blue-500 focus-within:ring-opacity-20"
            >
              <!-- Stripe Elements se montará aquí -->
            </div>
            @if (!cardElement) {
            <div
              class="absolute inset-0 flex items-center justify-center text-gray-400 text-sm pointer-events-none"
            >
              Cargando formulario de tarjeta...
            </div>
            }
          </div>
          <div class="text-xs text-gray-400">
            Ingresa el número de tarjeta, fecha de vencimiento y CVC
          </div>
        </div>
        <!-- Mensaje de seguridad -->
        <div class="flex items-center mb-4 text-sm text-gray-400">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5 mr-2 text-gray-500"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
            />
          </svg>
          Tus datos están protegidos con encriptación de 256 bits
        </div>
        <!-- Mensajes de error/éxito -->
        @if (errorMessage) {
        <div class="mb-4 p-3 bg-red-900 text-red-300 rounded-md">
          {{ errorMessage }}
        </div>
        } @if (successMessage) {
        <div class="mb-4 p-3 bg-green-900 text-green-300 rounded-md">
          {{ successMessage }}
        </div>
        }
        <!-- Botón de Guardar -->
        <button
          type="button"
          (click)="saveCard()"
          class="w-full flex justify-center items-center py-3 px-4 border border-transparent rounded-md shadow-sm text-white bg-yellow-600 hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-600 transition-colors duration-200"
          [disabled]="isLoading"
        >
          @if (isLoading) {
          <span class="mr-2">
            <svg
              class="animate-spin h-5 w-5 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                class="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                stroke-width="4"
              ></circle>
              <path
                class="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
          </span>
          }
          <span class="flex items-center">
            @if (!isLoading) {
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5 mr-2"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
              />
            </svg>
            } Guardar Tarjeta
          </span>
        </button>
      </form>
    </div>
  </div>
</div>
}

<!-- Botón para abrir el modal (opcional, puede ser activado desde el componente padre) -->
@if (false) {
<button
  (click)="openModal()"
  class="bg-yellow-400 hover:bg-yellow-500 text-gray-950 font-medium py-2 px-4 rounded-lg transition duration-200"
>
  Agregar Tarjeta
</button>
}
